import { api } from "..";
const endpoint = "/api/physical-inventory-counts";

export const getPhysicalInventoryCountList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getPhysicalInventoryCountById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createPhysicalInventoryCount = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updatePhysicalInventoryCount = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deletePhysicalInventoryCount = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const freezeStock = async (picId) => {
  return await api.post(`${endpoint}/${picId}/freeze-stock`);
};

export const exportCSV = async (picId) => {
  return await api.get(`${endpoint}/${picId}/export-csv`, {
    responseType: "blob",
  });
};

export const uploadCsv = async (picId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await api.post(`${endpoint}/${picId}/upload-csv`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPICReport = async (picId) => {
  return await api.get(`${endpoint}/${picId}/report`);
};

export const adjustStock = async (picId) => {
  return await api.post(`${endpoint}/${picId}/adjust-stock`);
};